import rootReducer from '../redux/reducers/index'
import { legacy_createStore as createStore } from '@reduxjs/toolkit'

const store = createStore(rootReducer)

export default store